module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.0.0.box.279.493.1174.194.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.35.0.0.box.712.493.313.41.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0"
    }
  }), _vm._v("Chapter 2")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.35.0.1.box.279.614.1174.73.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.0.0"
    }
  }), _vm._v("Charles Bryson Simonton 1838-1911")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.35.1.0.box.212.859.687.1217.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0022.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.2.0.box.218.968.1306.1386.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.2.0.box.940.968.583.625.q.60"
    }
  }, [_vm._v("A prominent citizen of what is now the Salem Community, Captain Charles Bryson Simonton, served the people of Portersville and later Tipton County, Tennessee. Portersville was established by James Hodges in 1831 and continued as the center of the community until after the coming of the railroad in 1872.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.2.1.box.941.1614.583.302.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.1.0"
    }
  }), _vm._v("Charles B. Simonton was born in Tipton County in 1838 and was a graduate of Erskine College in Due West, South Carolina graduating in 1859.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.2.2.box.220.1938.1304.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.2.0"
    }
  }), _vm._v("There was a school in"), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.3.0"
    }
  }), _vm._v(" the south end of the"), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.4.0"
    }
  }), _vm._v(" village of Portersville, which was destroyed by fire in 1863. Simonton taught school there after his graduation from college in 1859.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.2.3.box.218.2207.1303.147.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.5.0"
    }
  }), _vm._v("Simonton enlisted as a private in Company "), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.3.0.0"
    }
  }), _vm._v("C, 9th Tennessee Infantry, and subsequently rose to the rank of"), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.4.0.0"
    }
  }), _vm._v(" captain. Severely wounded in the arm at the Battle of Perryville, Kentucky in"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.1.0.box.155.364.1299.153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.0.0"
    }
  }), _vm._v("\n1862, he was disabled from any further active duty during the war. At this time, Captain Simonton, at the solicitation of old friends, took charge of the school in the fall of 1863.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.155.364.1305.1997.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.1.box.155.528.1301.533.q.60"
    }
  }, [_vm._v("There being no school building in Portersville after the fire nor any nearby except the privately owned Wilson schoolhouse near the Salem Associate Reformed Presbyterian Church, Simonton opened a school in the church through the courtesy of its officials. He continued teaching there for several years as a majority of the patrons of the Portersville Academy were members of the church. During the first years after the war, Professor H.M. Lynn, a classmate of Captain Simonton, was associated with him at the Academy. He remained at the school for some time after the captain entered the realm of politics.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.2.box.156.1070.1300.263.q.60"
    }
  }, [_vm._v("This school was an incorporated institution, controlled by a board of trustees, and was enjoying greater rights and privileges than were ordinarily conferred on \"old field schools.\" The Academy always employed college-trained men as principals, which was rarely the case in schools in the county.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.3.box.158.1343.1298.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.3.0"
    }
  }), _vm._v("Captain Simonton remained at the head of the school until 1868 when he was elected circuit court clerk. In 1870, he was again elected clerk of the circuit court of Tipton County, and he took advantage of the opportunity to study law.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.4.box.158.1559.1302.466.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.4.0"
    }
  }), _vm._v("Simonton began his practice in Covington in 1873 after being admitted to the bar. Four years later, he was elected to the Tennessee legislature and became the editor of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tipton ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Record ")]), _vm._v("newspaper—a paper later to be absorbed by the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Covington ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Leader. ")]), _vm._v("He was elected to the Forty-Sixth Congress in 1879 and was reelected for a second term two years later. He served as chairman of the Tennessee Democratic Convention in 1886. Six years later, he was a presidential elector for the ticket of President Grover Cleveland.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.5.box.159.2047.1299.152.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.5.0"
    }
  }), _vm._v("In his later years, Simonton served as president of the Covington City School Board and was a United States district attorney for the district of Tennessee from 1895 to 1898.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.6.box.160.2209.1297.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.6.0"
    }
  }), _vm._v("He died in Covington in 1911 and is buried in the Munford Cemetery.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.7.box.214.2316.1216.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.7.0"
    }
  }), _vm._v("(Historical Research by James Allen Smith, January 24, 1972.)")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.1.0.box.312.368.1102.2028.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.37.1.0.box.549.368.626.30.q.90"
    }
  }, [_vm._v("A SOLDIER'S RECOLLECTIONS")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0"
    },
    attrs: {
      "id": "para.37.1.1.box.429.452.868.89.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.0.0"
    }
  }), _vm._v("Brief Sketch of the Organization of Company C, "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.1.0"
    }
  }), _vm._v("           9th Tennessee Regiment "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.2.box.314.613.1099.391.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.3.0.0"
    }
  }), _vm._v("Editors Leader—At your request and that of several other friends, I now furnish you some of the principal facts in regard to Company C, Ninth Tennessee Regiment, recited by me in my remarks at the unveiling of the monument on the 29th of May, 1895, together with some introductory statements, and so give those who feel inclined an opportunity to file away this much of the record of this gallant company.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.3.box.312.1014.1102.885.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.3.1.0"
    }
  }), _vm._v("Captains DJ. Wood and James I. Hall were the principal movers and promoters in enlisting and organizing the company. They took steps in this direction a few days after Ft. Sumter was fired on, by calling a meeting at the Mountain Academy, where Capt. Hall was teaching school, as he now is and has been since the close of the war. I had just closed my second session of school at the Portersville Academy with the parade of a public examination and an exhibition at night. The Mountain, Portersville and even Covington were rural districts then, without railroad connection, and the news of public affairs traveled slowly. At Portersville we had a mail only twice a week by horseback rider from Covington to Raleigh. The evening my school closed the Memphis Appeal was received, which gave account of the firing upon Ft. Sumter, but with my duties as master of a school and manager of what I thought was a great exhibition, I never saw the paper or knew of the actual opening of the civil war until the next morning.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.4.box.314.1909.1098.139.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.3.2.0"
    }
  }), _vm._v("Within two or three days I received by messenger a note requesting my presence at the meeting called to be held at the Mountain Academy.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.5.box.313.2059.1100.337.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.3.3.0"
    }
  }), _vm._v("Up to this time Tennessee had declined to secede. Isham G. Harris was governor of the State and known to be in favor of secession, but he had no power to call for volunteers and no way to maintain, or arm and equip them if their services should be tendered him, but we were well satisfied that if we organized ourselves into a company he would never order us to disperse. The old men of the Mountain, Dickey Hall,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.1.0.box.266.363.1098.140.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  }), _vm._v("\nLansing Hall, John N. Hall, James W. Hall, Mr. Slitt, Mr. Elam, the Calhouns,—in fact, all the old men in the community—were there.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.1.0.box.263.363.1104.2038.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.1.box.263.513.1104.1888.q.60"
    }
  }, [_vm._v("There were no fiery speeches; they were all of one mind. Lincoln had called for the 75,000 ninety-day volunteers; the war, they thought, was inevitable. How to arm, equip and maintain a company until the state might secede, or if she failed to do so, then until our services might be accepted by the Confederacy, were the questions discussed. Calculations were made and it was determined that at least $5000 would be necessary, and within a few hundred of this amount was subscribed within a few minutes. The enlistments as I remember were 25 or 26. It was determined to hold another meeting a few days later at Clopton Campground to secure the remaining subscriptions necessary and procure further enlistments. A paper was given me to secure enlistments at and around Portersville. I also gave one for a like purpose to my friend and former classmate, H.M. Lynn, who was teaching school at Mount Zion. A paper for enlistments was also sent to Covington, but I do not remember to whom. As I recall it, Jas. W. Hall presided over the meeting at the Mountain and Benjamin Adams over the meeting at Clopton. At this latter meeting the subscription was completed and a number of additional recruits had been obtained, though the directions were not to solicit any recruits except persons of good character and steady habits. A day was set for the election of officers and organization of the company. I am sorry I have no memoranda to give me the exact date, but I am sure it was not later than the first of May 1861, and I think it was about the 25th of April. We met in the old Clopton church, across the branch from its present location. Capt. Wood, a man of sturdy virtues and who had had some experience in a campaign to Mexico, was elected captain by acclamation. We looked up to him as the fountain of all military knowledge. Capt. Hall, with a like unanimity, was made first lieutenant. He attempted, with great sincerity, to decline the honor, preferring to carry a musket and march in the ranks. He gave it as his honest opinion that he was poorly adapted to perform the duties of an officer, but he thought he could carry"), _c('span', {
    staticClass: "gstxt_sup"
  }), _vm._v(" a gun well enough and make a pretty fair private soldier. The boys admired him"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.39.1.0.box.315.361.1103.1041.q.60"
    }
  }, [_vm._v("\nfor his modesty, but passed on to second Lieutenant. Some gentleman proposed my name. Taking the cue from Lieut. Hall, I protested. It is very probable I was also very sincere, for I did not know the simplest military maneuvers or word of command even and I guess it occurred to me just then that an officer was expected to lead the men always in the face of danger, and if need be, to teach them by example how to die, and these reflections made me modest. I really wanted to avoid that post of distinction and—danger. Robt. W. Lemmon, a delicate and gentle-mannered, boyish-looking young man, but, as the sequel showed, of very cool courage, was chosen without opposition as third Lieutenant. At the expiration of our term of enlistment, twelve months, the company was reorganized instead of disbanding, and in the reorganization Lieut. Lemmon declined to stand for reelection and took his place as a private in the company, where he had served as an officer. He was subsequently discharged on account of feeble health, but declined to be released from duty, and fell while fighting in the ranks at New Hope Church in the Georgia campaign, 1864, with his discharge in his pocket. Peace to his memory.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.1.0.box.315.361.1104.2039.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.1.box.316.1411.1103.890.q.50"
    }
  }, [_vm._v("There was a spirited contest over the election of non-commissioned officers, except as to orderly sergeant. To this place J.D. Calhoun, whom all the boys called Dan, was elected by acclamation. He was a brother-in-law of Capt. DJ. Wood, a popular young man, recently married; and his memory is invested with special interest because he was the first victim in our company to the casualties of war. He sickened and died while we were in the camp of instruction at Union City—almost before we were accustomed to camp duties. When the election was over the roll of officers stood as follows: Commissioned officers, D.J. Wood Captain, Jas. I. Hall first lieutenant, C.B. Simonton second lieutenant, Robert W. Lemmon third lieutenant; sergeant, J.D. Calhoun orderly sergeant, W.H. Foster, second sergeant, J.R. McCreight third sergeant, S.J. Bradshaw fourth sergeant; corporals, M. Munford first corporal, H.M. Lynn second corporal, Wm. Camp Bell third corporal, Newt McMullen fourth corporal.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.2.box.319.2311.1099.89.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.2.0"
    }
  }), _vm._v("The above men were the offices we were entitled to fill, but having our hand in, we proceeded to elect a commissary,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.40.1.0.box.251.364.1106.138.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0"
    }
  }), _vm._v("\nan ensign, a surgeon and a chaplain, so that to the roster above given there was this addition: Wm. Young ensign, Ed Jones commissary, T.A. Kyle surgeon, J.W. Winford chaplain.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.251.364.1110.2041.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.257.511.1102.948.q.60"
    }
  }, [_vm._v("The company consisted rank and file of sixty men, but applications for enlistment were constantly coming in. It was solemnly resolved that no more recruits would be received except by the vote of the whole company and all applications were thereafter voted on with the particularity of a secret order in receiving new members. We then adopted as our company's name that of \"Southern Confederates.\" We were ordered by our gallant captain into camp immediately. We found the tents and other conveniences of the camp ground well adapted to breaking us gradually into camp life. Each volunteer brought his blanket; our home people supplied us with choice rations, the young ladies cheered us almost daily with their presence. It was a sort of picnic time, but we managed to get a \"Hardees' Tactics\" and learned something about forming line, counting off by twos and fours, right face, front, right dress, and we marched around to the monotone hep, hep of our gallant captain, and at the word hep we brought down our left foot with a tremendous stamp that almost made the earth tremble.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.254.1469.1107.936.q.60"
    }
  }, [_vm._v("At our organization, a committee was appointed to purchase uniforms for the whole company, which soon reached the full limit of 100 men rank and file, and to procure blankets etc., for these who were unable to provide for themselves conveniently. Gray was already the color of the Confederacy, but gray cloth was scarce. Our committee had difficulty in procuring enough cloth of any kind to make 106 uniform suits. The merchants of Memphis offered to have some beautiful jeans ordered from the factories in North Carolina, but the demand was so great that it would probably be several weeks before orders could be filled, and we really feared we would be in the midst of active service and perhaps the war ended before we could get our uniforms. Finally several hundred yards of a dingy, slaty colored jeans (it was mere courtesy to call it gray, and it was rough finished at that) was found and selected by the committee."), _c('sup', [_vm._v("1")]), _vm._v(" To say the boys who were expecting an elegant uniform were disappointed is putting it mildly; but they came nearer rebelling still when they saw the calico of a sickly hospital"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.1.0.box.312.368.1103.591.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.0.0"
    }
  }), _vm._v("\nyellow which was to make the stripes on the pants and adorn the collars of the coats. Each volunteer considered himself a gentleman as well as a soldier, but when the tailors came to take our measure and the good women and patriotic ladies with their offer to make up the garments, all was serene once more. So it was that various associations tended not only to make our uniforms bearable, but when we finally donned them with our hickory shirts, we were really proud of them, as well as ourselves, and we just wished the whole Yankee nation could see us once in the performance of such military movements as we had learned, alt"), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.0.0"
    }
  }), _vm._v("hough we did not have a gun.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.1.0.box.312.368.1109.2032.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.315.967.1100.390.q.60"
    }
  }, [_vm._v("It was now a full company of 106 men, rank and file; as fine a body of men, according to numbers, as ever tendered their services, their lives and their swords to monarch, sovereign or commonwealth. The enlistments had been made not only from the Mountain, Portersville and Covington, but from Mt. Zion, Randolph, Mason and Stanton. They came from school-room, from college, from the farm, the counting-room and the workshop.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.316.1365.1105.936.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.3.1.0"
    }
  }), _vm._v("I recall the names of twenty who were college graduates or came direct from college to the company. There were perhaps more. There were two ministers of the gospel and at least one theological student, W.H. Price. The great bulk of the company was young men between the ages of twenty and twenty-five. Two of our members W.M. Carnes and Holmes Cummins, if the test had been applied, had not reached the legal age of enlistment—eighteen years. There were four married men (two of them, J.W. Winford and Debro Slaughter) were discharged at the camp of instruction at Union City, and I overlooked their names and stated at the unveiling the number was only two in all. There were three widowers, two of them without families. A member of the company, who had reached thirty years, passed among us as an elderly man, entitled to great respect and to have first choice at all soft snaps. Among these was Ed Jones whom we made company commissary. The boys played a practical joke on him occasionally, but they never resented his red hot reprimands and fierce abuse.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.3.box.319.2310.1098.90.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.3.2.0"
    }
  }), _vm._v("On the 6th of May 1861, Tennessee seceded. There was then no longer any apprehension about arms being supplied"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.1.0.box.269.362.1100.440.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.0.0"
    }
  }), _vm._v("\netc., for forthwith came the call for volunteers and we tendered our services to the governor immediately, asked to be sworn in and armed at once. After some days came an order to report to the camp of organization at Jackson, Tenn., on May 22, 1861. The intervening time we passed in camp Clopton hardening up our muscles by daily drilling, and when off duty engaged in running, jumping and other athletic sports and entertaining our lady friends when they visited us, which was quite often.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.266.362.1103.2036.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.1.box.267.812.1101.1388.q.60"
    }
  }, [_vm._v("The ladies of the county at an expense of forty dollars purchased material which their deft fingers converted into a beautiful Confederate flag to be presented to us on the eve of our departure, which was fixed for the afternoon of May 21, 1861. This was to be a memorable occasion. Nothing like it had ever been seen in Tipton county. Miss Mollie D. Thompson, at one time a teacher in the Tipton Female Seminary, had been selected by the ladies to make the presentation. Well knowing her patriotism, her skill in composition, her grace of person and manner, our captain was more troubled about his reply than he would have been about arranging the details of a battle. He procured a copy of her address in advance and turned it over to Junius Hall and myself to frame a fitting reply, which we did in the highest style of the art known to us. When we read it to the captain, he was not as loud in his praise as we expected, but he took it graciously. Later he informed us that he could not memorize our lofty expressions, and such as he could remember would not fit in his mouth. The fact is, like a sensible man as he always was he had determined to be himself and make his response in his own way. A great crowd was in attendance, sorrowful but proud mothers and sisters, venerable fathers who fein would take their boys' place, proud of them as they could be, but their hearts trembling for the uncertain fate that awaited them. Major Morgan of Covington, who appeared to me one of the most princely men I ever saw, was in evidence, as well as all the old men who took an interest in organizing the company, and many more.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.2.box.266.2209.1099.189.q.50"
    }
  }, [_vm._v("We did some of the best drilling we were capable of. About 11 o'clock we marched in front of the stand erected for Miss Thompson's convenience, and in a tender touching, but firm voice she addressed us and very gracefully presented the flag.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.1.0.box.311.360.1115.2040.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.0.box.311.360.1109.543.q.60"
    }
  }, [_vm._v("The sentiments she expressed were loudly applauded. I have that address before me now. Of course some of the hopes she fondly indulged were never realized, but the address is interesting now. When quiet was restored, our captain responded in a very gallant and chivalrous manner, acquitting himself quite to the satisfaction of the whole company, and June Hall and myself observed with satisfaction that the captain in the midst his ardor wove in unconsciously one or two at least of our high flown phrases which, in our judgment, gave luster to his sensible and patriotic speech like diamonds on a kingly crown.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.1.box.317.912.1105.1237.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0"
    }
  }), _vm._v("When Capt. Wood had responded to Miss Thompson and accepted the flag at her hands, he turned to our stalwart ensign-elect, Wm. Young, who looked brave enough and strong enough to thresh a whole Yankee regiment himself, and said, \"I now place it in the hands of our noble and heroic color bearer.\" Here handing him the flag, he continued, \"Take this standard and protect and defend it as you would your life; unfurl it to the breeze, and may it wave and wave on forever until nations shall learn war no more.\" I think I never saw a man look so brave as Ensign Bill Young did just then. There were no Yankees near and there were any number of beautiful and admiring women looking proudly at him. Ensign Young took Capt. Wood's oratory in a very literal sense and he proceeded then and there to unfurl the flag and wave it, too. This was a sort of climax. The cymbals clashed, the drum beat and a shout went up. Mr. Ensign Young, as he bravely waved the beautiful flag, seemed to us and everybody at Clopton to be about the biggest man in the Confederacy, and we all felt a little disappointed that each one of us had not been elected ensign; but realizing that we all could not be color-bearers, we silently swore that we would defend the flag even more bravely than the man who bore it. I give the reader here the presentation address of Miss Thompson and Capt. Wood's gallant reply:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.2.box.321.2159.1105.241.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.2.0"
    }
  }), _vm._v("Southern Confederates—The scene before us is one of no common interest. The fathers, sons and brothers of this people are here in military array to receive our strongest and perhaps last testimonial of our esteem. You now go forth to battle for your homes and your firesides, for your"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.44.1.0.box.265.362.1102.188.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.0.0"
    }
  }), _vm._v("\nliberty and these defenseless ones. You bid adieu to your kindred, and sever the dearest ties of nature, to fight for your country, but you go in a just cause, and the God of battles will be with you.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.1.0.box.265.362.1105.2040.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.1.box.266.560.1104.543.q.60"
    }
  }, [_vm._v("The flag, too, while it now sends a thrill of martial pride through every heart, is at the same time calculated to produce and reflections, as it takes the place of that of our once glorious and now degraded union; that under which our forefathers fought and which we have so long delighted to honor; that union which has sent abroad vast stores of wealth and scattered far and wide religious and political wisdom. But its knell has sounded, its glory has forever departed, and the time has arrived when the two sections must sever their bands which can no longer be held by unnatural interest and friendship.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.2.box.266.1111.1101.940.q.60"
    }
  }, [_vm._v("Northern fanaticism would place on us a yoke more oppressive than that of Great Britain. Denying our independence as a nation, they would have the wealth of the South to enrich their northern coffers. Forgetting we are brethren, they would send bloodshed and devastation throughout the land. They care not for the widows' tears; the cry of the orphan and the oppressed is unheeded. Totally void of every principle of honor, \"They would uproar the universal peace, confound all unity on earth\" to subjugate us. But this will be a harder task to prove than has perhaps been imagined. 'Tis true they have the advantage in weapons for warfare, but we have strong arms and brave hearts that will spill the last drop of blood in defense of our liberty. Subjugate the South! As we might they undertake to stop the current of the mighty ocean as to conquer Southern sons with their bloodthirsty minions. Our mothers have instilled within us a different principle. Our freedom was given us by God Himself, and rather than live in bondage we will die in the struggle for independence.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.3.box.267.2061.1100.341.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.3.0"
    }
  }), _vm._v("This is a time to try men's souls and women's too; an era unequaled in the annals of history. Let every true patriot arm himself for the contest, and in the battlefield be assured lies our only safe protection. There is the place to guard your homes. Though you leave your families sad and desolate, the duty you are about to perform is to them as well as your country. A duty the neglect of which would be sufficient to"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.45.1.0.box.310.358.1108.391.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.0.0"
    }
  }), _vm._v("\ndebase you from the kingdom of grace and glory, and render you a reproach to your family and a traitor to the land that gave you birth. The time is here for immediate action. The perfidy of the North has deceived us long enough. Where are now our Northern men of Southern principles? All vanished! \"Let us be up and doing with a heart for any fate.\" Ours is a just cause, a conflict forced upon us. Forget not Him who alone can give us victory.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA42"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.1.0.box.310.358.1112.2038.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.1.box.310.759.1109.939.q.60"
    }
  }, [_vm._v("We would congratulate you, Capt. Wood, on your noble company who so promptly offered their services. Formed as it is of the chivalry, intelligence, refinement and piety of our land, you have every reason to be hopeful. You go with a band of pure hearts, actuated alone by principles of equity, justice and liberty. \"What stronger breast-plate than a heart unstained? Thrice is he armed who hath his quarrel just.\" Go, then, in the strength of Israel's God to conquer and contest, \"knowing the race is not to the swift nor the battle to the strong.\" Women's prayers will unceasingly attend you. She can not fight in the field, but she will importune heaven in your behalf and will ever be happy to be engaged in works of love and mercy for the soldiers of her land. Without a murmur she will see her husband and sons join in this warfare, with no assurance of seeing them again, but she will pray for your safe and speedy return, when this shall be an independent and happy nation; and should you die on the battlefield, she \"knows you die no felon's death, but a warrior's weapon frees a warrior's soul.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.2.box.318.1709.1104.687.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.2.0"
    }
  }), _vm._v("And now, Capt. Wood, permit me in behalf of the rest of my sex, to present you and your gallant band this flag as a testimonial of our admiration, heartfelt gratitude and entire confidence in your undertaking. May it never be trailed in the dust, but be borne triumphantly in every battle. Unfurl it to the breeze, and may it inspire you with fresh courage, and incite others to join you in this holy cause. May the time soon come when the influence of our Southern Confederacy shall be felt from ocean to ocean, when it shall be the admiration of all nations and the oppressed of every land shall seek its protection. And when at last this flag has been shredded by the elements may your names be handed down through future generations as your country's honor and your nation's glory.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.1.0.box.217.362.1153.2047.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.0.box.265.362.1100.644.q.60"
    }
  }, [_vm._v("And when you come to pass from earth away, whether amid the din of battle or in your own peaceful homes, may you, when you stand in the twilight of two worlds, be enabled to look back on this as the greatest act of your life, and may it suffice to obliterate from God's book of justice all your past offenses. God grant you may return safely to your kindred crowned with laurels of victory; but should you not be permitted to meet them again on earth, they will have the consolation of knowing you died in a great, a glorious and a just cause, and 'tis our sincere prayer to Almighty God that you may join hands on the shining shores of heaven and bask forever in the eternal sunshine of liberty, where wars are forgotten and peace is perfected, God bless you, gentlemen.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.46.1.1.box.217.1039.382.45.q.60"
    }
  }, [_vm._v("Capt. Wood's reply:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.2.box.265.1118.1101.841.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.2.0"
    }
  }), _vm._v("Miss Thompson and the ladies whom you represent—I wish very briefly to express for myself and company our heartfelt appreciation of the exhibition we have witnessed here today. We are indeed in the midst of a crisis. The rights, equality and justice for which our fathers fought have been denied us, our overtures for peace and justice have been treated with contempt; our arguments and entreaties have been met with insults, and we are now menaced with invasion. There is no alternative left us but to meet the fanatic on the battlefield and teach him a lesson which he has refused to learn in Washington City. It does not become us here to boast of valor yet to be shown, of deeds of daring yet to be performed, for the Bible says to those who are putting on the armor not to boast as those who put it off; but it would be strange indeed if our hearts should lack courage or our arms want nerve when we are thus so warmly encouraged by such a host of fair women and brave men.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.3.box.267.1969.1103.440.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.3.0"
    }
  }), _vm._v("The noble part which you and the dear ladies you represent have taken in this great cause is enough to encourage the patriot's heart, enough to mottle with the blush of shame the coward's cheek. We go then with fresh zeal to engage in the cause we have espoused, and allow me to say that I haven't one single doubt as to the final result of this conflict. The States already seceded can bring 50,000 heroes, and more if necessary, into the field. These men, aroused with the true spirit of chivalry and patriotism,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.47.1.0.box.319.358.1101.191.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.0.0"
    }
  }), _vm._v("\nincensed by the perfidy and treachery of Abe Lincoln, led on by the gallant Davis, and battling for their homes and firesides, will be invincible by any force the enemy can bring against them.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.1.0.box.318.358.1103.844.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.1.box.318.559.1103.643.q.60"
    }
  }, [_vm._v("Miss Thompson, you alluded to the stars and stripes. You have well said its glory has departed. It is a venerated thing of the past. It was gloriou"), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.2.0.0"
    }
  }), _vm._v("s when borne by hands of patriots and heroes, but when on the 5th of last March it was placed in the hands of Abraham and from being the banner of "), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.3.0.0"
    }
  }), _vm._v("liberty and equality it changed into a badge of tyranny and oppression, it became contemptible and disgusting in the eyes of every patriot. We ther"), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.4.0.0"
    }
  }), _vm._v("efore discard it forever and accept this as the standard of our country. Under its folds we will rally and drive back the Northern invaders from ou"), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.5.0.0"
    }
  }), _vm._v("r soil. We accept it as the highest mark of consideration which you can confer on us, we accept it as a sacred trust which we promise to defend with our lives, our fort"), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.6.0.0"
    }
  }), _vm._v("unes and our"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.48.2.0.box.320.1519.1100.180.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.0.0"
    }
  }), _vm._v("\nsacred honor. I now place it in the hands of our heroic color-bearer. Take this standard and protect it and defend it as you would your life. Unfurl it to the breeze, and may it wave and wave on until nations shall learn war no more.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.1.0"
    }
  }), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.47.2.0.box.218.1220.1304.1128.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0023.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA45"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.48.1.0.box.218.582.1304.876.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0024.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.2.0.box.320.1519.1101.839.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.1.box.320.1719.1101.488.q.60"
    }
  }, [_vm._v("Miss Thompson, we appreciate every word you have spoken to us today. May you who have spoken so kindly to us and all the dear ladies who have by works and labors of love encouraged our hearts and strengthened our hands, may you live long to grace the land of your nativity, the joyous pride of the sunny South; may you live long to nerve the patriot's arm and encourage his desponding spirit, and if we meet no more here, may we one and all shake hands on the banks of Deliverance, where the wicked cease from troubling and the weary are at rest. Ladies, I thank you.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.2.box.322.2217.1099.141.q.60"
    }
  }, [_vm._v("After all, William Young, so proud of the trust committed to him, never had an opportunity to wave it as color bearer in presence of the enemy. Dan Calhoun, as already stated,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.49.1.0.box.317.359.1102.342.q.60"
    }
  }, [_vm._v("\ndied while we were in the camp of instruction at Union City, and William Young was elected to the very responsible post of orderly sergeant in his place. After the speech making and the cheering there was some quick step marching under our new banner and then, \"Break ranks, march!\" to give opportunity for our last dinner at Clopton and a chance to say farewell.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA46"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.1.0.box.317.359.1106.2039.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.1.box.318.711.1105.1687.q.60"
    }
  }, [_vm._v("Whatever other soldierly accomplishments might have been wanting to the gallant \"Southern Confederates\" because of the lack of having seen service, they had at least magnificent appetites and could get away with rations quite as successfully as the most experienced veterans. During the first month of service at Clopton, we had lived on the fat of the land—that is, when Commissary Jones"), _c('sup', [_vm._v("2")]), _vm._v(" would let us. All provisions sent to camp were turned over to his care and keeping. In the midst of the greatest profusion he tried to introduce a strict economy that would have well become the later days of the Confederacy. That is to say, he locked up the boiled hams, the odorous roast lamb, the chicken and turkey, pies and cakes, and from the remnants of the last meal he sheared together bits of ham and chunks of beef, potatoes, onions, pies, pickles, chicken, cornbread, light bread, etc., stirred and boiled and so made a grand hash which the boys denominated \"cush.\" This stern old commissary used to swear by all the gods in the catalogue of false deities that not one of us should have a single bite to eat but \"cush;\" that it was a part of a soldier's duty to learn economy and especially learn to eat anything; he reminded us every day that ere long we would be delighted to have food far less palatable than his cush; he insisted it was the best hash ever made and used to gulp it down himself by the big spoonful to encourage us to partake. There was universal rebellion, however, and peace generally was only restored at last by the stern old commissary unlocking the boxes of hams, cakes, etc. At the last dinner at Clopton the old commissary even was toned down and became gentle and did not mar the occasion by his everlasting and universal pot of \"cush.\" It was rather a sad dinner. We were proud of our company and fond of our friends. We put on a little of the swaggering air as we thought soldiers ought to do; we rallied our friends, we joked and laughed, but somehow the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.50.1.0.box.266.362.1107.2031.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.0.0"
    }
  }), _vm._v("\njokes were flat and our laughter sounded hollow and dismal. We munched over the most tempting viands, for we found that somehow the mouthfuls stuck in our throats. After dinner in all the shady nooks were little family groups; mother had sought opportunity to speak a last word to her dear boy, to give him a Bible, a kiss and her blessing. She could not trust herself to the general farewell in public; she knew she would break down, and by a sort of tacit understanding no tears were to be shed that day. \"God bless and protect you, my dear boy, and restore you to these arms again, but whatever your fate, let me always hear that under all circumstances you did your duty and did it well,\" were the final words that greeted my ear, and a like message every mother"), _c('a', {
    attrs: {
      "id": "GBS.PA48"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.0.0.0"
    }
  }), _vm._v(" present gave her boy that day. It is perfectly astonishing how brave and self possessed they were. There were other sweet, sad farewells in sequestered nooks about and around the sacred bill. Little parties, each soldier boy with his lassie, strolled hither and thither; they walked gaily enough, but there was an air of unwelcome sadness which refused to be banished. In the friendly, inviting shade vows of everlasting constancy where plighted and lips that never had met before touched in the last farewell, and the transport of such parting seemed rich compensation for years of toil, hardship and danger to come. The photographer at old Bloomington had been rushed with business, and tiny little lockets were in great demand. But now the time of departure was at hand. A great train of wagons"), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.0.0"
    }
  }), _vm._v(" was drawn up. Rev. D.H. Cummings1, pastor of the Presbyterian church at Covington, known now to every member of the company and the personal friend of most of us before and who had held services in camp for us the two Sunday evenings preceding, invoked the protection of the God of battles for us and earnestly prayed his blessing upon our cause. Orderly Sergeant Calhoun was busily engaged in distributing the boys in the numerous wagons, forming company, so to speak, by wagons. In the first wagon he deposited Ensign Young with the banner, attended by a volunteer guard of honor. I have said we had no arms. I should have said except knives. All the color guard and nearly every member of the company were armed with huge knives, which were carried in a sheath like a sword—a real")]), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.52.1.0.box.273.361.1105.2043.q.60"
    }
  }, [_vm._v("\nbarbaric, bloodthirsty weapon, made by an ingenious blacksmith, Bill Ward. Later on they were put to the ignominious service of cutting bread and chopping up tough beef instead of drawing blood from the treacherous foes of our dear country. We had no knapsacks and each soldier packed up his small belongings as best he could. These consisted of his blanket, a change of undergarments, his Bible and keepsakes, an occasional book of light literature, but more likely some history of Napoleon, or Cromwell's wars—or perhaps of Frederick the Great, a pencil or fountain pen, note paper and envelopes, and all the literary inclined had huge rolls of foolscap or a large blank book to keep a diary, which the possessor fancied would be an authentic history of the war when the last gun should be fired. How many diaries were there started during the way I do not know, but precious few of them ever amounted to more than a few dull pages. Good thoughtful old Commissary Jones was loaded up boxes of ham, pies and other provisions to regale us by the way and sustain us at Jackson till we were sufficiently in touch with the state to \"draw rations.\" When Orderly Calhoun had seen everything loaded and taken his seat in the first wagon, the drivers tightened up their lines, cracked their whips and away drove the gallant Southern Confederates from the presence of father, mother, brothers, sisters, sweethearts, neighbors and friends, and with their prayers and blessings following them. Away they drove to their unknown fates, to discharge the highest duties of a citizen, the defense of native land. Away they drove where honor beckoned, where fame offered an imperishable name, but God of mercy protect them, for they drove where pestilence lurks, where death crouches in their pathway. They were to become a part of the army of Tennessee and whenever the armies under Polk, Bragg, the Johnsons, Beauregard and Hood sent up a shout of victory, their voices joined the proud huzzah; in all the great battles of the West—Shiloh, Perryville, Murfreesboro, Missionary Ridge, Chickamauga, the campaigning in Georgia, the battles of Franklin and Nashville—some of these boys were to be found among the wounded that strewed the track of battle and among the pale-faced dead on all these battle-swept fields were found the stiffened corpses of brave and lamented members of")]), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.53.1.0.box.317.358.1102.241.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.0.0"
    }
  }), _vm._v("\nthis gallant company, and at last, when the last roll was called at Greensboro, NC, a battle-scarred remnant, still preserving the autonomy of the company—the first company Tipton gave to the defense of the South—answered proudly to their names.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.50.1.0.box.266.362.1107.2031.q.60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.51.0.0.box.216.226.1309.2160.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0025.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA49"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.52.1.0.box.273.361.1105.2043.q.60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.53.1.0.box.317.358.1102.391.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.1.box.318.608.1099.141.q.60"
    }
  }, [_vm._v("Noble, gallant band of patriots, accomplished soldiers, first to respond to the call of arms, proud am I to have been associated with you.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fdbefb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0026.vue
// module id = 75
// module chunks = 0